import React from 'react';
import { useNavigate } from 'react-router-dom';

// Components
import { DataGrid, ViewButton } from '@arredo/reactjs-ui';
import { Spinner } from '@arredo/reactjs-ui';

// Material UI
import { Paper, Typography, Grid, Box } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

// Hooks
import useReferrals from '../../../hooks/referrals/useReferrals';
import useQueryString from '../../../hooks/queryString/useQueryString';
import useAuthorize from '../../../hooks/user/useAuthorize';

import ReferralFilters from './ReferralFilters';

// Models
import { columns } from '../../../models/ReferralEntities';
import { Permissions } from '../../../models/Roles';

const Referrals = () => {
    const isAuthorized = useAuthorize();
    const { setParameterSearch, filters, clearFilters } = useQueryString();
    const { referrals, loading, totalPage, printReferral, loadingPrint } = useReferrals(filters);

    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        });

    const handlePrint = async (itemId) => {
        const res = await printReferral(itemId);

        if (res.html) {
            const wnd = window.open("about:blank", "", "_blank");
            wnd.document.write(res.html);
            wnd.print();
        }
    }

    return (
        <>
            {loadingPrint && <Spinner lockScreen message='Procesando' />}
            <Grid container spacing={1}>
                <Grid size={12}>
                    <Box component={Paper} padding={2}>
                        <Typography variant="h4">
                            Remitos
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={12}>
                    <ReferralFilters
                        filters={filters}
                        setFilters={setParameterSearch}
                        clearFilters={clearFilters}
                    />
                </Grid>
                <Grid size={12}>
                    <DataGrid
                        rows={referrals}
                        columns={columns}
                        loading={loading}
                        paginationProps={{
                            count: totalPage,
                            page: filters?.pageNumber || 1,
                            onChange: handleChangePage
                        }}
                        actions={({ row }) => (
                            <>
                                {
                                    isAuthorized([Permissions.StockView]) &&
                                    <ViewButton to={`/stocks/referrals/${row.id}`} />
                                }
                                {
                                    isAuthorized([Permissions.StockPrint]) &&
                                    <Tooltip title='Imprimir remito' aria-label='Imprimir remito'>
                                        <IconButton onClick={() => handlePrint(row.id)} size="large">
                                            <PrintIcon />
                                        </IconButton>
                                    </Tooltip>
                                }

                            </>
                        )}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default Referrals;